import styled from "styled-components";

import { Button } from "components/ui";

import { media } from "constants/media";

export const StyledFileUpload = styled.div`
    margin-bottom: 16px;
    width: 100%;

    ${media.mdUp} {
        margin: 0;
    }
`;

export const LabelsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;

    ${media.mdUp} {
        flex-direction: row;
        margin-bottom: 20px;
    }
`;

export const StyledFileUploadLabel = styled.div`
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
`;

export const StyledFileUploadSubLabel = styled.div`
    color: var(--color-grey-60);
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 1px;
    line-height: 16px;
    text-transform: uppercase;
`;

export const StyledUploadButton = styled(Button)<{ hasError?: boolean }>`
    background-color: ${props =>
        props.hasError ? "var(--color-red-light)" : "transparent"};
    border: ${props =>
        props.hasError ? "1px dashed var(--color-red-50)" : ""};
    margin-top: 8px;
    width: fit-content;

    ${media.mdUp} {
        margin: 0 0 0 auto;
    }
`;

export const InputLabelIconWrapper = styled.div`
    align-items: center;
    border-radius: 50px;
    color: var(--color-white);
    display: flex;
    height: 32px;
    justify-content: center;
    margin-right: 16px;
    transition-duration: var(--default-transition-duration);
    transition-property: color, background-color;
    transition-timing-function: ease;
    width: 32px;
`;

export const InputLabel = styled.label<{ hasError?: boolean }>`
    align-items: center;
    background-color: ${props =>
        props.hasError ? "var(--color-red-light)" : "var(--color-grey-45)"};
    border: ${props =>
        props.hasError
            ? "1px dashed var(--color-red-50)"
            : "1px dashed var(--color-grey-50)"};
    border-radius: 24px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 16px;
    min-height: 72px;
    width: 100%;
`;

export const ErrorMessage = styled.div`
    color: var(--color-red-50);
    font-size: var(--type-sub-text-font-size-sub-text);
    font-weight: 700;
    line-height: var(--type-sub-text-line-height);
`;

export const InputLabelText = styled.div`
    align-items: center;
    color: var(--color-grey-60);
    display: flex;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
`;

export const StyledInput = styled.input`
    display: none;
`;

export const FilesWrapper = styled.ol`
    list-style: none;
`;

export const UploadedFile = styled.li`
    align-items: center;
    border: 1px solid var(--color-grey-45);
    border-radius: 27px;
    display: flex;
    height: 40px;
    list-style: none;
    margin: 4px 0;
    padding: 12px 8px;
    width: 100%;

    ${media.mdUp} {
        margin: 8px 0;
    }
`;

export const UploadedFileName = styled.div`
    color: var(--color-black);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    margin-right: 16px;
    max-width: calc(100% - 112px);
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const UploadedFileSize = styled.div`
    color: var(--color-grey-55);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    max-width: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const UploadedErrorMessage = styled.div`
    color: var(--color-error);
    font-size: 14px;
    line-height: 20px;
`;

export const DeleteButton = styled.button`
    all: unset;
    cursor: pointer;
    margin-left: auto;
`;
